import { NgModule } from '@angular/core';
import { SharedCommonModule } from '@spaq/shared';
import { AppAccountDisabledComponent, AppWrongSiteComponent } from '@shared/ui';
import { AppNotAllowdComponent, AppNotFoundComponent } from './pages';

@NgModule({
	declarations: [AppNotAllowdComponent, AppNotFoundComponent],
	imports: [SharedCommonModule, AppAccountDisabledComponent, AppWrongSiteComponent]
})
export class GatewayModule {}
